<template>
  <album>
    <div class="album-detail">
      <div class="profile-box">
        <div class="profile-img">
          <img
            src="http://st2.depositphotos.com/1001094/11036/i/110/depositphotos_110362060-stock-photo-elegant-stylish-handsome-man-black.jpg"
          />
        </div>
        <div class="text">
          <span>What do you think about {{ photographerName }}?</span>
        </div>
        <div class="rating">
          <button
            :class="{ select: ratingIndex >= 1 || tempRatingIndex >= 1 }"
            v-on:mouseover="handleRatingOver(1)"
            v-on:mouseout="handleRatingOut(1)"
            @click="handleSelectRating(1)"
          ></button>
          <button
            :class="{ select: ratingIndex >= 2 || tempRatingIndex >= 2 }"
            v-on:mouseover="handleRatingOver(2)"
            v-on:mouseout="handleRatingOut(2)"
            @click="handleSelectRating(2)"
          ></button>
          <button
            :class="{ select: ratingIndex >= 3 || tempRatingIndex >= 3 }"
            v-on:mouseover="handleRatingOver(3)"
            v-on:mouseout="handleRatingOut(3)"
            @click="handleSelectRating(3)"
          ></button>
          <button
            :class="{ select: ratingIndex >= 4 || tempRatingIndex >= 4 }"
            v-on:mouseover="handleRatingOver(4)"
            v-on:mouseout="handleRatingOut(4)"
            @click="handleSelectRating(4)"
          ></button>
          <button
            :class="{ select: ratingIndex >= 5 || tempRatingIndex >= 5 }"
            v-on:mouseover="handleRatingOver(5)"
            v-on:mouseout="handleRatingOut(5)"
            @click="handleSelectRating(5)"
          ></button>
        </div>
        <span class="point">{{ ratingPoint }}</span>
        <div class="edit-box" v-if="!reviewFinished">
          <button class="normal" @click="handleShowReviewWriteForm">
            <span>REPORT</span>
          </button>
          <!--<button class="confirm" @click="handleShowReviewWriteForm"><span>YES</span></button>-->
        </div>
      </div>
      <div class="report form" v-if="showReportForm">
        <textarea placeholder="write report" v-model="txtReport"></textarea>
        <div class="edit-box">
          <button class="normal" @click="hideForm">
            <span>CANCEL</span>
          </button>
          <button class="confirm" @click="save('report')">
            <span>CONFIRM</span>
          </button>
        </div>
      </div>
      <div class="review form" v-if="showReviewForm">
        <textarea placeholder="write review" v-model="txtReview"></textarea>
        <div class="edit-box">
          <button class="normal" @click="hideForm">
            <span>CANCEL</span>
          </button>
          <button class="confirm" @click="saveComment">
            <span>CONFIRM</span>
          </button>
        </div>
      </div>
      <div></div>
      <div class="download-box">
        <a :href="data.downloadUrl" target="_blank" class="link">
          <span>Download zip file</span>
          <span>(link will deactivate after 2 week)</span>
        </a>
      </div>
      <div class="lists">
        <photo-album-box-1
          v-for="(item, index) in data.uploaded"
          :key="index"
          :image="item.thumbnailFullPath"
        ></photo-album-box-1>
      </div>
    </div>
  </album>
</template>

<script>
import Album from './Album'
import PhotoAlbumBox1 from '../common/PhotoAlbumBox1'
import { getAlbumDetail } from '../../api/album'
import { setReview } from '../../api/review'

export default {
  name: 'album-detail',
  components: { PhotoAlbumBox1, Album },
  data: function() {
    return {
      album: '',
      images: [],
      photographerName: '',
      tempRatingIndex: 0,
      ratingIndex: 0,
      ratingPoint: 0,
      showReportForm: false,
      showReviewForm: false,
      txtReport: '',
      txtReview: '',
      reviewFinished: false,
      data: ''
    }
  },
  created() {
    console.log('route: ', this.$route.params)
    this.getData()

    // 리뷰를 등록 했다면, 등록 표시를 해준다.
    // 리뷰를 등록 할때 예약에도 해주고, 리뷰 스키마에도 해주고, 평가는 포토그래퍼의 서비스에 해준다.
  },
  methods: {
    saveComment() {
      console.log(this.tempRatingIndex)
      console.log(this.ratingPoint)
      console.log(this.ratingIndex)
      console.log(this.txtReview)
      const userId = this.$store.getters.userInfo.uid,
        serviceId = this.data.serviceId,
        reservationId = this.data.id,
        userName = this.data.userName,
        rating = parseInt(this.ratingPoint, 10),
        comment = this.txtReview

      setReview(
        userId,
        serviceId,
        reservationId,
        userName,
        rating,
        comment
      ).then(() => {
        this.hideForm()
        this.reviewFinished = true
      })
    },
    getData() {
      getAlbumDetail(this.$route.params.albumId).then(result => {
        console.log('get album detail result: ', result)
        this.data = result

        if (result.rating > 0 && result.hasOwnProperty('rating') > 0) {
          this.reviewFinished = true
          this.ratingPoint = result.rating
          this.ratingIndex = result.rating
          this.tempRatingIndex = result.rating
        }
      })
    },
    handleRatingOver(index) {
      if (this.reviewFinished === true) {
        return
      }
      this.tempRatingIndex = index
      this.ratingPoint = String(1.0 * index)
    },

    handleRatingOut() {
      if (this.reviewFinished === true) {
        return
      }

      this.tempRatingIndex = 0
      this.ratingPoint = String(1.0 * this.ratingIndex)
    },

    handleSelectRating(index) {
      if (this.reviewFinished === true) {
        return
      }

      this.ratingIndex = index
      this.ratingPoint = String(1.0 * index)
    },

    handleShowReportWriteForm() {
      this.txtReport = ''
      this.txtReview = ''
      this.showReviewForm = false
      this.showReportForm = true
    },

    handleShowReviewWriteForm() {
      this.txtReport = ''
      this.txtReview = ''
      this.showReportForm = false
      this.showReviewForm = true
    },

    hideForm() {
      this.showReportForm = false
      this.showReviewForm = false
      this.txtReport = ''
      this.txtReview = ''
    },

    save(type) {
      console.log(type)
      // todo: 빈 값 제거 해줘야 한다.
      if (type === 'review') {
        if (this.txtReview === '') {
          return
        }
      } else {
        if (this.txtReport === '') {
          return
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.album-detail {
  margin-top: 40px;
  .lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: hidden;
    width: 120%;
    .photo-album-box-1 {
      margin-bottom: 38px;
      margin-right: 40px;
    }
  }

  .profile-box {
    position: relative;
    width: 100%;
    height: 151px;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    .profile-img {
      position: relative;
      width: 110px;
      height: 110px;
      margin: 20px auto auto 20px;
      img {
        width: 110px;
        height: 110px;
      }
    }

    .text {
      position: absolute;
      height: 26px;
      width: 90%;
      margin: 20px auto auto 146px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      span {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 1px;
        color: #000000;
      }
    }

    .rating {
      position: absolute;
      margin: 60px auto auto 146px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      button {
        outline: none;
        background: url('../../assets/images/unrated.svg');
        width: 28px;
        height: 26px;
        background-size: 28px 26px;
        border: none;
        padding: 0;
        margin: 0 -4px 0 0;
        &:hover {
          outline: none;
          background: url('../../assets/images/rated.svg');
          width: 28px;
          height: 26px;
          background-size: 28px 26px;
          border: none;
          padding: 0;
          margin: 0 -4px 0 0;
        }

        &.select {
          outline: none;
          background: url('../../assets/images/rated.svg');
          width: 28px;
          height: 26px;
          background-size: 28px 26px;
          border: none;
          padding: 0;
          margin: 0 -4px 0 0;
        }
      }
    }

    .point {
      position: absolute;
      margin: 49px auto auto 316px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      font-family: Georgia;
      font-size: 36px;
      font-weight: bold;
      font-style: italic;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #000000;
    }
  }

  .download-box {
    width: 100%;
    position: relative;
    margin: 30px 0;
    /*border: 1px dotted rebeccapurple;*/
    .link {
      padding: 0;
      outline: none;
      border: none;
      background: transparent;
      font-family: Poppins;
      font-size: 16px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
      color: #000000;
      a:link,
      a:hover,
      a:visited,
      a:active {
        text-decoration: none;
      }

      span:nth-child(1) {
        font-weight: 600;
        color: #000bff;
      }
    }
    .social {
      position: absolute;
      top: -10px;
      right: 0;
      div {
        width: 50px;
        height: 50px;
        display: inline-block;
        margin: 0 0 0 -5px;
        overflow: hidden;
        padding: 0;
        border: 1px solid #dbdbdb;
      }
    }
  }

  .edit-box {
    position: absolute;
    top: 15px;
    right: 21px;
    width: 250px;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: right;
    color: #000000;

    .normal {
      margin: 5px 0 0 0;
      font-weight: 300;
      font-size: 14px;
      width: 150px;
      height: 50px;
      border-radius: 2px;
      background-color: #ffffff;
      border: solid 1px #dddddd;
      color: #000000;
    }

    .cancel {
      margin: 5px 0 0 0;
      font-weight: 300;
      font-size: 14px;
      width: 150px;
      height: 50px;
      border-radius: 2px;
      background-color: #ffffff;
      border: solid 1px #dddddd;
      color: #000000;
    }

    .confirm {
      margin: 13px 0 0 0;
      border: none;
      font-weight: 600;
      font-size: 14px;
      width: 150px;
      height: 50px;
      border-radius: 2px;
      background-color: #000bff;
      color: #ffffff;
    }
  }

  .form {
    position: relative;
    width: 1080px;
    height: 151px;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    margin: 30px auto 0 auto;
    textarea {
      background: #f5f5f5;
      color: #000;
      margin: 20px;
      border: none;
      width: 850px;
      height: 94px;
      padding: 10px;
      outline: none;
      resize: none;
    }
  }
}
</style>
